<template>
<div class="contractAuthorized">
    <el-table
      :data="listsTables"
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
      tooltip-effect="dark"
      border
      @selection-change="handleSelectionChange"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column type="selection" prop="id"></el-table-column>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column prop="contractUser.name" label="发起方"></el-table-column>
      <el-table-column prop="signStartTime" label="发起时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
         <div class="handlerBoxCenter">
            <div class="cursorPointer goSign" @click="goSign(scope.row)">
              <div>
                  <span class="icon"></span>
                  <span class="iconDscp">去签署</span>
              </div>
            </div>
            <div class="cursorPointer detail" @click="detailFn(scope.row.id)">
              <div>
                <span class="icon"></span>
                <span class="iconDscp">详情</span>

              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="authorizationTrigger" v-if="listsTables.length>0">
      <div class="fl">
        <el-checkbox v-model="checkbox"></el-checkbox>
        <span class="textAlign ft12 authorTion cursorPointer" @click="handelClick">授权</span>
      </div>
      <el-pagination
        v-if="showPaginationp"
        @size-change="handleSizeChangep"
        @current-change="handleCurrentChangep"
        :current-page="currentPagep"
        :page-sizes="pageSizesp"
        :page-size="pageSizep"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalp"
      ></el-pagination>
    </div>
</div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "../../../../common/Dialog.vue";
export default {
  props:['message'],
  data(){
    return{
      listsTables:[],
      checkbox: false,
      showPaginationp:false,
      multipleSelection:[],
      ifx: [],
    }
  },
  methods:{
    init() {
      var queryStres = {
        status: "4",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        status: "1"
      };
      BaseApi.createRpcToken("/contract/v2/list", queryStres).then(
        data => {
          this.listsTables = data.datas.list.list;
        },
        data => {
          console.log(data);
        }
      );
    },
    goSign(detail) {
      console.log(detail);
      let isCanReject = 1;
      if (detail.contractUser.userId == localStorage.userId) {
        isCanReject = 0;
      }
      let taskId = this.getTaskId(detail.taskList, "SIGN");
      this.$router.push(
        `/personal/sign/index/signature?isHandwriting=false&id=${
          detail.id
        }&taskId=${taskId}&isCanReject=${isCanReject}`
      );
    },
    getTaskId(data, flag) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].actionCode === flag) {
          return data[i].taskId;
        }
      }
    },
    detailFn(id) {
      this.$router.push({
        path: "/personal/sign/detail",
        query: {
          id: id
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val)
      this.ifx = [];
      for (var j = 0; j < this.multipleSelection.length; j++) {
        this.ifx.push(this.multipleSelection[j].id);
      }
      if (val.length > 0) {
        this.checkbox = true;
      } else {
        this.checkbox = false;
      }
      console.log(this.ifx)
    },
    handelClick() {
      if (this.multipleSelection.length>0) {
            this.$parent.handelClickFnP()
            console.log(this.ifx+'0-----')
            this.$emit('getData',this.ifx)
      } else {
        this.$message.error("请选择合同");
      }
    },
  },
  mounted(){
    this.init()
  },
  components:{
    BaseApi,
    Dialog
  }
}
</script>
<style lang="scss">
.contractAuthorized { 
  th {
    text-align: center;
    padding: 0;
  }
  .cell {
    padding: 0;
    white-space: nowrap;
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 3.5%;
    .cell{
      padding:0;
    }
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 14.6%;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 20.1%;
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 14.1%;
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 12.2%;
  }
  th:nth-child(6),
  td:nth-child(6) {
    width: 16.1%;
    padding: 0 3%;
    .handlerBoxCenter{
      display: flex;
      justify-content: space-around;
      .cursorPointer{
        .icon{
          display: inline-block;
        height: 14px;
        width: 12px;
        vertical-align: middle;
        margin-right: 4px;
        }
      }
      .detail  {
        .icon {
          background: url('./../../../../../assets/images/personalSignHome/sign_icon_nor.png');
          background-size: 100% 100%;
        }
        &:hover {
          .icon {
            background: url('./../../../../../assets/images/personalSignHome/sign_icon_hov.png');
            background-size: 100% 100%;
          }
          color: #e88078;
        }
      }
      .goSign{
        .icon {
          background: url('./../../../../../assets/images/personalSignHome/details_icon_nor.png');
          background-size: 100% 100%;
        }

        &:hover {
          .icon {
            background: url('./../../../../../assets/images/personalSignHome/details_icon_hov.png');
            background-size: 100% 100%;
          }
          color: #e88078;
        }
      }
    } 
  }
  table {
    tr {
      height: 32px;
      th {
        background: #f9f9f9;
      }
      td {
        text-align: center;
      }
    }
    thead {
      width: 100%;
      background: #f9f9f9;
      color: #505050;
      input {
        vertical-align: middle;
        width: 12px;
        height: 12px;
      }
    }
    tbody {
      tr {
        color: #969696;
        height: 48px;
        input {
          width: 12px;
          height: 12px;
        }
      }
    }
    .el-checkbox__inner:hover {
      border-color: #e88078;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #e88078;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #e88078;
      background: #e88078;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #dcdfe6;
      background: #fff;
    }
  }
  .authorizationTrigger {
    margin-top: 22px;
    height: 32px;
    line-height: 32px;
    .el-checkbox {
      margin-left: 18px;
      margin-right: 18px;
    }
    div {
      input[type="checkbox"] {
        width: 12px;
        height: 12px;
        border: 1px solid #db4437;
        margin: 0 22px;
        vertical-align: middle;
      }
      .el-checkbox__inner:hover {
        border-color: #e88078;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #e88078;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #e88078;
        background: #e88078;
      }
      .authorTion {
        display: inline-block;
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        color: #db4437;
      }
      .authorTion:hover {
        background-color: #a5303d;
        color: #fff;
      }
    }
  }
}
</style>
